export default __webpack_public_path__ + "static/media/icon-palme.f58153c3.svg";